import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "text-secondary" }
const _hoisted_4 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_5 = { class: "col-sm-12 d-flex justify-content-between" }
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = {
  for: "toggleVisibility",
  class: "text-capitalize-first"
}
const _hoisted_8 = { class: "form-check form-switch d-flex align-items-center justify-content-center" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "row mb-2 mt-2" }
const _hoisted_13 = { class: "col-sm-12 overflow-auto" }
const _hoisted_14 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_15 = {
  key: 1,
  class: "table table-bordered"
}
const _hoisted_16 = { class: "bg-light" }
const _hoisted_17 = {
  rowspan: "2",
  class: "text-capitalize-first"
}
const _hoisted_18 = {
  rowspan: "2",
  class: "text-capitalize-first"
}
const _hoisted_19 = {
  key: 0,
  rowspan: "2",
  class: "text-capitalize-first"
}
const _hoisted_20 = {
  colspan: "6",
  class: "text-center"
}
const _hoisted_21 = {
  key: 1,
  rowspan: "2",
  class: "text-capitalize"
}
const _hoisted_22 = { class: "text-secondary" }
const _hoisted_23 = {
  key: 2,
  rowspan: "2",
  colspan: "2",
  class: "text-capitalize-first text-center"
}
const _hoisted_24 = {
  key: 3,
  rowspan: "2",
  class: "text-capitalize"
}
const _hoisted_25 = {
  key: 4,
  rowspan: "2",
  class: "text-capitalize"
}
const _hoisted_26 = {
  key: 5,
  rowspan: "2",
  class: "text-capitalize-first"
}
const _hoisted_27 = { class: "text-capitalize" }
const _hoisted_28 = {
  key: 0,
  class: "text-capitalize"
}
const _hoisted_29 = { class: "text-secondary" }
const _hoisted_30 = { class: "bg-white align-middle" }
const _hoisted_31 = {
  key: 0,
  class: "fa fa-eye-slash"
}
const _hoisted_32 = { class: "bg-white align-middle text-center" }
const _hoisted_33 = ["title"]
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "bg-white" }
const _hoisted_36 = { class: "form-check form-switch d-flex align-items-center justify-content-center" }
const _hoisted_37 = ["onUpdate:modelValue", "disabled"]
const _hoisted_38 = {
  key: 0,
  class: "bg-white"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { style: {"width":"100px"} }
const _hoisted_41 = ["readonly", "onUpdate:modelValue"]
const _hoisted_42 = {
  key: 0,
  style: {"width":"100px"}
}
const _hoisted_43 = ["readonly", "onUpdate:modelValue"]
const _hoisted_44 = {
  key: 1,
  style: {"width":"100px"}
}
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 2,
  style: {"width":"100px"}
}
const _hoisted_47 = ["value"]
const _hoisted_48 = {
  key: 3,
  style: {"width":"100px"}
}
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 4,
  style: {"width":"100px"}
}
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 5,
  style: {"width":"100px"},
  class: "text-center"
}
const _hoisted_53 = ["onClick", "title"]
const _hoisted_54 = {
  key: 6,
  style: {"width":"100px"},
  class: "text-center"
}
const _hoisted_55 = ["onClick", "title"]
const _hoisted_56 = {
  key: 0,
  class: "badge bg-secondary ms-1"
}
const _hoisted_57 = {
  key: 1,
  class: "bg-light"
}
const _hoisted_58 = {
  colspan: "100%",
  class: "p-0"
}
const _hoisted_59 = { class: "p-3" }
const _hoisted_60 = { class: "mb-2" }
const _hoisted_61 = { style: {"max-width":"500px"} }
const _hoisted_62 = {
  key: 2,
  class: "bg-light"
}
const _hoisted_63 = {
  colspan: "100%",
  class: "p-0"
}
const _hoisted_64 = { class: "p-3" }
const _hoisted_65 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_66 = { class: "mb-0" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_69 = { class: "table table-sm table-bordered" }
const _hoisted_70 = { style: {"width":"100px"} }
const _hoisted_71 = ["value", "onInput"]
const _hoisted_72 = ["value", "onInput"]
const _hoisted_73 = ["value", "onInput"]
const _hoisted_74 = ["value", "onChange"]
const _hoisted_75 = { value: "" }
const _hoisted_76 = ["value"]
const _hoisted_77 = { class: "text-center" }
const _hoisted_78 = ["onClick", "title"]
const _hoisted_79 = {
  key: 1,
  class: "text-muted text-center py-3"
}
const _hoisted_80 = {
  key: 0,
  class: "text-center text-muted py-4"
}
const _hoisted_81 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_82 = { class: "table table-striped table-sm align-middle" }
const _hoisted_83 = { style: {"width":"220px"} }
const _hoisted_84 = { style: {"width":"260px"} }
const _hoisted_85 = { class: "text-nowrap" }
const _hoisted_86 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_87 = { style: {"white-space":"normal"} }
const _hoisted_88 = { class: "text-secondary mb-1" }
const _hoisted_89 = {
  class: "mb-0",
  style: {"max-height":"220px","overflow":"auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "modalLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      (_ctx.isAdmin || _ctx.isOperator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.comment')) + ": " + _toDisplayString(_ctx.trader?.comment ?? 'n/a'), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAdmin || _ctx.isOperator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.only_active")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    id: "toggleVisibility",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyActive) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    style: {"cursor":"pointer"}
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.onlyActive]
                  ])
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-sm text-capitalize-first",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showHistory && _ctx.showHistory(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.helper.trans('labels.history')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchGroups && _ctx.searchGroups(...args))),
            placeholder: _ctx.helper.trans('labels.search_merchant_or_group'),
            autocomplete: "off"
          }, null, 40, _hoisted_11), [
            [_vModelText, _ctx.searchQuery]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.groupsLoaded && _ctx.visibleGroupIds.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.no_merchant_groups_found')), 1))
            : (_openBlock(), _createElementBlock("table", _hoisted_15, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_16, [
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.helper.trans('labels.traffic_group')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("th", {
                      rowspan: "2",
                      class: "text-capitalize-first",
                      style: {"width":"0px"}
                    }, null, -1)),
                    (!_ctx.isTeamLead)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_ctx.helper.trans('labels.priority')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.reward_fee_percent')), 1),
                    (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_21, [
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.teamlead')) + " ", 1),
                          _createElementVNode("small", _hoisted_22, _toDisplayString(_ctx.trader?.mainTeamLead?.name ?? 'n/a'), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isTeamLead)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.min_max_store_reward')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.total')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.ranges')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.store_blacklist')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.trader')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trader?.teamLeads, (teamLead, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id || teamLead?.id === _ctx.user?.id)))
                          ? (_openBlock(), _createElementBlock("th", _hoisted_28, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.teamlead')) + " ", 1),
                              _createElementVNode("small", _hoisted_29, _toDisplayString(teamLead?.name ?? 'n/a'), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSettings, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.trafficGroupId
                    }, [
                      (_ctx.onlyActive && item.enabled || !_ctx.onlyActive)
                        ? (_openBlock(), _createElementBlock("tr", {
                            key: 0,
                            class: _normalizeClass({'bg-warning': !_ctx.isValidRewards(item)})
                          }, [
                            _createElementVNode("td", _hoisted_30, [
                              _createTextVNode(_toDisplayString(item._trafficGroup?.name) + " ", 1),
                              (item._trafficGroup?.isHidden)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              (item._trafficGroup?.type === _ctx.Direction.PAY_IN)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    title: _ctx.helper.trans(`direction.${item._trafficGroup?.type}`),
                                    class: "fa-regular fa-circle-down text-primary"
                                  }, null, 8, _hoisted_33)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                                : _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 1,
                                    title: _ctx.helper.trans(`direction.${item._trafficGroup?.type}`),
                                    class: "fa-regular fa-circle-up text-warning"
                                  }, null, 8, _hoisted_34)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                            ]),
                            _createElementVNode("td", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((item.enabled) = $event),
                                  disabled: _ctx.isTeamLead,
                                  id: "autoclose",
                                  class: "form-check-input",
                                  style: {"cursor":"pointer"},
                                  type: "checkbox",
                                  role: "switch"
                                }, null, 8, _hoisted_37), [
                                  [_vModelCheckbox, item.enabled]
                                ])
                              ])
                            ]),
                            (!_ctx.isTeamLead)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["btn btn-sm w-100", _ctx.priorityClass(item.priority)]),
                                    onClick: _withModifiers(($event: any) => (_ctx.togglePriority(item)), ["prevent"])
                                  }, _toDisplayString(item.priority), 11, _hoisted_39)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_40, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control form-control-sm",
                                readonly: _ctx.isTeamLead && _ctx.trader?.mainTeamLead?.id !== _ctx.user?.id,
                                "onUpdate:modelValue": ($event: any) => ((item._rewardFeePercent) = $event)
                              }, null, 8, _hoisted_41), [
                                [_vModelText, item._rewardFeePercent]
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trader?.teamLeads, (teamLead, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id || teamLead?.id === _ctx.user?.id)))
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-control form-control-sm",
                                        readonly: _ctx.isTeamLead && _ctx.trader?.mainTeamLead?.id !== _ctx.user?.id || !teamLead,
                                        "onUpdate:modelValue": ($event: any) => ((item._teamLeadRewardFeePercents[index]) = $event)
                                      }, null, 8, _hoisted_43), [
                                        [_vModelText, item._teamLeadRewardFeePercents[index]]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                              ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                                  _createElementVNode("input", {
                                    class: "form-control form-control-sm",
                                    readonly: "",
                                    value: item._teamLeadRewardFeePercent
                                  }, null, 8, _hoisted_45)
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isTeamLead)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                                  _createElementVNode("input", {
                                    class: "form-control form-control-sm",
                                    readonly: "",
                                    value: item._groupMinRewardPercent
                                  }, null, 8, _hoisted_47)
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isTeamLead)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_48, [
                                  _createElementVNode("input", {
                                    class: "form-control form-control-sm",
                                    readonly: "",
                                    value: item._groupMaxRewardPercent
                                  }, null, 8, _hoisted_49)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                              ? (_openBlock(), _createElementBlock("td", _hoisted_50, [
                                  _createElementVNode("input", {
                                    class: "form-control form-control-sm",
                                    readonly: "",
                                    value: _ctx.getTotalRewardValue(item)
                                  }, null, 8, _hoisted_51)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                              ? (_openBlock(), _createElementBlock("td", _hoisted_52, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-secondary",
                                    onClick: ($event: any) => (_ctx.toggleRanges(item.trafficGroupId)),
                                    title: _ctx.helper.trans('labels.toggle_ranges')
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fa", _ctx.expandedRanges[item.trafficGroupId] ? 'fa-eye-slash' : 'fa-eye'])
                                    }, null, 2)
                                  ], 8, _hoisted_53)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && (_ctx.trader?.mainTeamLead?.id === _ctx.user?.id)))
                              ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-secondary",
                                    onClick: ($event: any) => (_ctx.toggleStoreBlacklist(item.trafficGroupId)),
                                    title: _ctx.helper.trans('labels.store_blacklist')
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["fa", _ctx.expandedStoreBlacklist[item.trafficGroupId] ? 'fa-eye-slash' : 'fa-eye'])
                                    }, null, 2),
                                    ((item._excludedStores?.length ?? 0) > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(item._excludedStores?.length), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_55)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true),
                      (_ctx.expandedStoreBlacklist[item.trafficGroupId])
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                            _createElementVNode("td", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("h6", _hoisted_60, _toDisplayString(_ctx.helper.trans('labels.store_blacklist')) + " - " + _toDisplayString(item._trafficGroup?.name), 1),
                                _createElementVNode("div", _hoisted_61, [
                                  _createVNode(_component_StoreMultiselect, {
                                    multiple: true,
                                    small: "",
                                    modelValue: item._excludedStores,
                                    "onUpdate:modelValue": ($event: any) => ((item._excludedStores) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.expandedRanges[item.trafficGroupId])
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                            _createElementVNode("td", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", _hoisted_65, [
                                  _createElementVNode("h6", _hoisted_66, _toDisplayString(_ctx.helper.trans('labels.fee_ranges')) + " - " + _toDisplayString(item._trafficGroup?.name), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: ($event: any) => (_ctx.addNewRange(item.trafficGroupId))
                                  }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.add_range')), 1)
                                  ], 8, _hoisted_67)
                                ]),
                                (item.traderFeeByDealAmount && item.traderFeeByDealAmount.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                      _createElementVNode("table", _hoisted_69, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.min_sum')), 1),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.max_sum')), 1),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.fee')), 1),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                                            _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.helper.trans('labels.actions')), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.traderFeeByDealAmount, (range, rangeIndex) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: rangeIndex,
                                              class: _normalizeClass({'table-danger': !_ctx.isRangeValid(range)})
                                            }, [
                                              _createElementVNode("td", null, [
                                                _createElementVNode("input", {
                                                  type: "text",
                                                  class: _normalizeClass(["form-control form-control-sm", {'is-invalid': !_ctx.isRangeValid(range)}]),
                                                  value: range.minSum,
                                                  onInput: ($event: any) => (_ctx.updateRangeField(item.trafficGroupId, rangeIndex, 'minSum', $event.target.value))
                                                }, null, 42, _hoisted_71)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("input", {
                                                  type: "text",
                                                  class: _normalizeClass(["form-control form-control-sm", {'is-invalid': !_ctx.isRangeValid(range)}]),
                                                  value: range.maxSum,
                                                  onInput: ($event: any) => (_ctx.updateRangeField(item.trafficGroupId, rangeIndex, 'maxSum', $event.target.value))
                                                }, null, 42, _hoisted_72)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("input", {
                                                  type: "text",
                                                  class: "form-control form-control-sm",
                                                  value: range._feePercent,
                                                  onInput: ($event: any) => (_ctx.updateRangeField(item.trafficGroupId, rangeIndex, '_feePercent', $event.target.value))
                                                }, null, 40, _hoisted_73)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("select", {
                                                  class: _normalizeClass(["form-control form-control-sm", {'is-invalid': !_ctx.isRangeValid(range)}]),
                                                  value: range.currency,
                                                  onChange: ($event: any) => (_ctx.updateRangeField(item.trafficGroupId, rangeIndex, 'currency', $event.target.value))
                                                }, [
                                                  _createElementVNode("option", _hoisted_75, _toDisplayString(_ctx.helper.trans('labels.select_currency')), 1),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCurrencies, (currency) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                      key: currency,
                                                      value: currency
                                                    }, _toDisplayString(currency), 9, _hoisted_76))
                                                  }), 128))
                                                ], 42, _hoisted_74)
                                              ]),
                                              _createElementVNode("td", _hoisted_77, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn btn-sm btn-outline-danger",
                                                  onClick: ($event: any) => (_ctx.removeRange(item.trafficGroupId, rangeIndex)),
                                                  title: _ctx.helper.trans('button.remove_range')
                                                }, _cache[10] || (_cache[10] = [
                                                  _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                                ]), 8, _hoisted_78)
                                              ])
                                            ], 2))
                                          }), 128))
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                      _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('messages.no_ranges_configured')), 1)
                                    ]))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
        ])
      ]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.history'),
        "dialog-class": "modal-xl",
        modelValue: _ctx.historyModal,
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-end",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.historyModal = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LoaderWrapper, { ref: "historyLoader" }, {
            default: _withCtx(() => [
              (_ctx.historyResponse.items.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("table", _hoisted_82, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_83, _toDisplayString(_ctx.helper.trans('labels.created_at')), 1),
                          _createElementVNode("th", _hoisted_84, _toDisplayString(_ctx.helper.trans('labels.initiator')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.settings')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyResponse.items, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id
                          }, [
                            _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.dateHelper.format(item.changedAt)), 1),
                            _createElementVNode("td", null, [
                              (item.initiator)
                                ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                    key: 0,
                                    user: item.initiator
                                  }, null, 8, ["user"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_86, "#" + _toDisplayString(item.initiatorId), 1))
                            ]),
                            _createElementVNode("td", _hoisted_87, [
                              _createElementVNode("div", _hoisted_88, _toDisplayString(item.trafficGroupName) + " (" + _toDisplayString(_ctx.helper.trans(`direction.${item.trafficGroupType}`)) + ") ", 1),
                              _createElementVNode("pre", _hoisted_89, _toDisplayString(_ctx.formatHistoryValue(item.newValue)), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    (_ctx.historyResponse.totalCount > _ctx.historyResponse.items.length)
                      ? (_openBlock(), _createBlock(_component_b_pagination, {
                          key: 0,
                          modelValue: _ctx.historyPage,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.historyPage) = $event)),
                            _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadHistory()))
                          ],
                          "total-rows": _ctx.historyResponse.totalCount,
                          "per-page": _ctx.historyResponse.limit,
                          limit: 20,
                          "prev-text": "Back",
                          "next-text": "Next",
                          align: "start",
                          "first-number": "",
                          "hide-goto-end-buttons": "",
                          "hide-ellipsis": ""
                        }, null, 8, ["modelValue", "total-rows", "per-page"]))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _: 1
          }, 512)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.historyModal = false), ["prevent"])),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _: 1
  }, 512))
}